import { render, staticRenderFns } from "./allsearch.vue?vue&type=template&id=7b6f422d&scoped=true"
import script from "./allsearch.vue?vue&type=script&lang=js"
export * from "./allsearch.vue?vue&type=script&lang=js"
import style0 from "./allsearch.vue?vue&type=style&index=0&id=7b6f422d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f422d",
  null
  
)

export default component.exports